import "bootstrap/dist/css/bootstrap.min.css"
import "./main.css"
import '@babel/polyfill'
import 'mutationobserver-shim'
import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import setupInterceptors from "@/services/setupInterceptors";
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2';
// import translation from '@/i18n/translations.json'
import {createI18n} from 'vue-i18n'

library.add(fas)

setupInterceptors(store)

const app = createApp(App)
    .use(router)
    .use(store)
    .use(VueSweetalert2)


app.component('font-awesome-icon', FontAwesomeIcon)
    .component('v-select', vSelect)


store.dispatch('resource/getResource').then(() => {
    let translation = {
        ge: store.state.resource.list
    }

    const i18n = createI18n({
        locale: 'ge',
        fallbackLocale: 'ge',
        messages: translation,
    })

    app.use(i18n);
    app.mount('#app')

})


import 'vue-select/dist/vue-select.css';
import "bootstrap/dist/js/bootstrap"
import 'sweetalert2/dist/sweetalert2.min.css';
import 'leaflet/dist/leaflet.css'

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');